import { createScopedLogger } from ".";

export const CC_LOG_VARIABLES = {
    booking: {
        vehicle: 'vehicle'
    }
}

// booking form
export const LOG_BOOK_VEHICLE_BookingInfo = createScopedLogger('booking', 'vehicle', 'BookingInfoChauffer');
export const LOG_BOOK_VEHICLE_SELECTION = createScopedLogger('booking', 'vehicle', 'VehicleSelection');

export const LOG_BOOK_PAYMENT_INFO = createScopedLogger('booking', 'payment', 'PaymentInfo');
export const LOG_BOOK_PAYMENT_FUNC_FILE = createScopedLogger('booking', 'payment', 'paymentFunc');

export const LOG_BOOK_COMPANY = createScopedLogger('booking', 'company', 'BookingInfoChauffer');

export const LOG_BOOK_SUB_TOTAL_COMPLETE_BOOKING = createScopedLogger('booking', 'completed', 'subTotal');

export const LOG_BOOK_ADDON_SERVICES = createScopedLogger('booking', 'addon');
export const LOG_BOOK_ADDON_SERVICES_ETA = createScopedLogger('booking', 'addon', 'eta');

export const LOG_BOOK_HYDRA_PROVIDER = createScopedLogger('booking', 'hydra');

// booking cue
export const LOG_CUE_BOOK = createScopedLogger('cue', 'booking');
export const LOG_CUE_BOOK_REDUCER = createScopedLogger('cue', 'booking', 'cueReducer');
export const LOG_CUE_BOOK_REAL_TIME_FILTER = createScopedLogger('cue', 'booking', 'realTimeHelper');

// booking cue
export const LOG_CUE_BOOK_LOAD_MORE = createScopedLogger('cue', 'booking', 'loadMoreData');

// MAP
export const LOG_MAP_BOOKING = createScopedLogger('map', 'booking');
export const LOG_MAP_DRIVER = createScopedLogger('map', 'driver');

//PROVIDER HYDRA